import { computed, type ComputedRef } from "vue";
import { useNewUiPreference } from "@/components/newUi/core/newUiPreference";

export const useNewUiEnabled = (): ComputedRef<boolean> => {
  const preference = useNewUiPreference();

  return computed(() => preference.value);
};
